var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _path24, _g2, _path25, _path26, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckInsThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.68629 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 40C44.5228 40 49 35.5228 49 30C49 24.4772 44.5228 20 39 20C33.4772 20 29 24.4772 29 30C29 35.5228 33.4772 40 39 40Z",
    fill: "#A6A8AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8002 33.102C41.7587 33.102 41.7172 33.0606 41.6758 33.0606C41.0533 32.8116 40.182 32.3136 40.182 31.6082C40.182 30.5293 41.4268 30.3635 41.5928 28.1643C41.7173 26.3801 40.7629 25.0938 38.9787 25.0938C37.1944 25.0938 36.2401 26.3801 36.3646 28.1643C36.5305 30.405 37.7753 30.5708 37.7753 31.6082C37.7753 32.3136 36.904 32.8116 36.2816 33.0606C36.2401 33.0606 36.1986 33.102 36.1571 33.102C35.8251 33.268 35.5762 33.6415 35.5762 34.0564C35.5762 34.6373 36.0326 35.0937 36.6135 35.0937H38.9787H41.3438C41.9247 35.0937 42.3811 34.6373 42.3811 34.0564C42.4226 33.6415 42.1737 33.268 41.8002 33.102Z",
    fill: "#BBBDBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 25C55.8954 25 55 25.8954 55 27V33C55 34.1046 55.8954 35 57 35H93C94.1046 35 95 34.1046 95 33V27C95 25.8954 94.1046 25 93 25H57Z",
    fill: "#DFE0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 43.125C167.473 43.125 173.125 37.4726 173.125 30.5C173.125 23.5274 167.473 17.875 160.5 17.875C153.527 17.875 147.875 23.5274 147.875 30.5C147.875 37.4726 153.527 43.125 160.5 43.125Z",
    fill: "#E1E1E1",
    fillOpacity: 0.75,
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 43.125C167.473 43.125 173.125 37.4726 173.125 30.5C173.125 23.5274 167.473 17.875 160.5 17.875C153.527 17.875 147.875 23.5274 147.875 30.5C147.875 37.4726 153.527 43.125 160.5 43.125Z",
    fill: "#D1D1D1",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 43C167.404 43 173 37.4036 173 30.5C173 23.5964 167.404 18 160.5 18C153.596 18 148 23.5964 148 30.5C148 37.4036 153.596 43 160.5 43Z",
    fill: "#D1D1D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 40.873C166.23 40.873 170.875 36.228 170.875 30.498C170.875 24.7681 166.23 20.123 160.5 20.123C154.77 20.123 150.125 24.7681 150.125 30.498C150.125 36.228 154.77 40.873 160.5 40.873Z",
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 43.125C167.473 43.125 173.125 37.4726 173.125 30.5C173.125 23.5274 167.473 17.875 160.5 17.875C153.527 17.875 147.875 23.5274 147.875 30.5C147.875 37.4726 153.527 43.125 160.5 43.125Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 40.877C166.23 40.877 170.875 36.2319 170.875 30.502C170.875 24.772 166.23 20.127 160.5 20.127C154.77 20.127 150.125 24.772 150.125 30.502C150.125 36.2319 154.77 40.877 160.5 40.877Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 71C44.5228 71 49 66.5228 49 61C49 55.4772 44.5228 51 39 51C33.4772 51 29 55.4772 29 61C29 66.5228 33.4772 71 39 71Z",
    fill: "#A6A8AB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8002 64.1019C41.7587 64.1019 41.7172 64.0606 41.6758 64.0606C41.0533 63.8116 40.182 63.3136 40.182 62.6082C40.182 61.5293 41.4268 61.3634 41.5928 59.1642C41.7173 57.38 40.7629 56.0938 38.9787 56.0938C37.1944 56.0938 36.2401 57.38 36.3646 59.1642C36.5305 61.4049 37.7753 61.5708 37.7753 62.6082C37.7753 63.3136 36.904 63.8116 36.2816 64.0606C36.2401 64.0606 36.1986 64.1019 36.1571 64.1019C35.8251 64.2679 35.5762 64.6414 35.5762 65.0563C35.5762 65.6372 36.0326 66.0936 36.6135 66.0936H38.9787H41.3438C41.9247 66.0936 42.3811 65.6372 42.3811 65.0563C42.4226 64.6414 42.1737 64.2679 41.8002 64.1019Z",
    fill: "#BBBDBF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 56C55.8954 56 55 56.8954 55 58V64C55 65.1046 55.8954 66 57 66H93C94.1046 66 95 65.1046 95 64V58C95 56.8954 94.1046 56 93 56H57Z",
    fill: "#DFE0E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 74.125C167.473 74.125 173.125 68.4726 173.125 61.5C173.125 54.5274 167.473 48.875 160.5 48.875C153.527 48.875 147.875 54.5274 147.875 61.5C147.875 68.4726 153.527 74.125 160.5 74.125Z",
    fill: "#F9F9F9",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 102C44.5228 102 49 97.5228 49 92C49 86.4772 44.5228 82 39 82C33.4772 82 29 86.4772 29 92C29 97.5228 33.4772 102 39 102Z",
    fill: "#A6A8AB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8002 95.1019C41.7587 95.1019 41.7172 95.0605 41.6758 95.0605C41.0533 94.8115 40.182 94.3136 40.182 93.6082C40.182 92.5293 41.4268 92.3634 41.5928 90.1642C41.7173 88.38 40.7629 87.0938 38.9787 87.0938C37.1944 87.0938 36.2401 88.38 36.3646 90.1642C36.5305 92.4049 37.7753 92.5708 37.7753 93.6082C37.7753 94.3136 36.904 94.8115 36.2816 95.0605C36.2401 95.0605 36.1986 95.1019 36.1571 95.1019C35.8251 95.2679 35.5762 95.6414 35.5762 96.0563C35.5762 96.6372 36.0326 97.0936 36.6135 97.0936H38.9787H41.3438C41.9247 97.0936 42.3811 96.6372 42.3811 96.0563C42.4226 95.6414 42.1737 95.2679 41.8002 95.1019Z",
    fill: "#BBBDBF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 87C55.8954 87 55 87.8954 55 89V95C55 96.1046 55.8954 97 57 97H93C94.1046 97 95 96.1046 95 95V89C95 87.8954 94.1046 87 93 87H57Z",
    fill: "#DFE0E1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 133C44.5228 133 49 128.523 49 123C49 117.477 44.5228 113 39 113C33.4772 113 29 117.477 29 123C29 128.523 33.4772 133 39 133Z",
    fill: "#A6A8AB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8002 126.102C41.7587 126.102 41.7172 126.061 41.6758 126.061C41.0533 125.812 40.182 125.314 40.182 124.608C40.182 123.529 41.4268 123.363 41.5928 121.164C41.7173 119.38 40.7629 118.094 38.9787 118.094C37.1944 118.094 36.2401 119.38 36.3646 121.164C36.5305 123.405 37.7753 123.571 37.7753 124.608C37.7753 125.314 36.904 125.812 36.2816 126.061C36.2401 126.061 36.1986 126.102 36.1571 126.102C35.8251 126.268 35.5762 126.641 35.5762 127.056C35.5762 127.637 36.0326 128.094 36.6135 128.094H38.9787H41.3438C41.9247 128.094 42.3811 127.637 42.3811 127.056C42.4226 126.641 42.1737 126.268 41.8002 126.102Z",
    fill: "#BBBDBF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 118C55.8954 118 55 118.895 55 120V126C55 127.105 55.8954 128 57 128H93C94.1046 128 95 127.105 95 126V120C95 118.895 94.1046 118 93 118H57Z",
    fill: "#DFE0E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11947_87552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 48,
    width: 27,
    height: 27
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M174 48H147V75H174V48Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M149.996 54.7233C148.483 57.0688 147.798 59.8534 148.051 62.6332C148.305 65.4131 149.481 68.0283 151.393 70.062C153.305 72.0957 155.842 73.431 158.601 73.855C161.36 74.2789 164.182 73.7673 166.616 72.4015C169.051 71.0357 170.958 68.8943 172.034 66.3187C173.11 63.7431 173.293 60.8815 172.554 58.1898C171.815 55.4981 170.196 53.1312 167.955 51.4665C165.714 49.8017 162.981 48.9347 160.191 49.0038L160.5 61.5L149.996 54.7233Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11947_87552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.996 54.7233C148.483 57.0688 147.798 59.8534 148.051 62.6332C148.305 65.4131 149.481 68.0283 151.393 70.062C153.305 72.0957 155.842 73.431 158.601 73.855C161.36 74.2789 164.182 73.7673 166.616 72.4015C169.051 71.0357 170.958 68.8943 172.034 66.3187C173.11 63.7431 173.293 60.8815 172.554 58.1898C171.815 55.4981 170.196 53.1312 167.955 51.4665C165.714 49.8017 162.981 48.9347 160.191 49.0038L160.5 61.5L149.996 54.7233Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.996 54.7233C148.483 57.0688 147.798 59.8534 148.051 62.6332C148.305 65.4131 149.481 68.0283 151.393 70.062C153.305 72.0957 155.842 73.431 158.601 73.855C161.36 74.2789 164.182 73.7673 166.616 72.4015C169.051 71.0357 170.958 68.8943 172.034 66.3187C173.11 63.7431 173.293 60.8815 172.554 58.1898C171.815 55.4981 170.196 53.1312 167.955 51.4665C165.714 49.8017 162.981 48.9347 160.191 49.0038L160.5 61.5L149.996 54.7233Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.661 70.3388C153.124 71.8015 154.927 72.8783 156.908 73.4727C158.889 74.0672 160.987 74.1606 163.013 73.7448C165.039 73.3289 166.931 72.4167 168.518 71.0899C170.105 69.7631 171.338 68.0632 172.106 66.1427C172.874 64.2222 173.154 62.141 172.92 60.0858C172.686 58.0305 171.945 56.0655 170.765 54.3669C169.585 52.6682 168.001 51.2891 166.156 50.353C164.312 49.417 162.264 48.9534 160.196 49.0037L160.5 61.5L151.661 70.3388Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 71.873C166.23 71.873 170.875 67.228 170.875 61.498C170.875 55.7681 166.23 51.123 160.5 51.123C154.77 51.123 150.125 55.7681 150.125 61.498C150.125 67.228 154.77 71.873 160.5 71.873Z",
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 74.125C167.473 74.125 173.125 68.4726 173.125 61.5C173.125 54.5274 167.473 48.875 160.5 48.875C153.527 48.875 147.875 54.5274 147.875 61.5C147.875 68.4726 153.527 74.125 160.5 74.125Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 71.877C166.23 71.877 170.875 67.2319 170.875 61.502C170.875 55.772 166.23 51.127 160.5 51.127C154.77 51.127 150.125 55.772 150.125 61.502C150.125 67.2319 154.77 71.877 160.5 71.877Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11947_87552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 79,
    width: 27,
    height: 27
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M174 79H147V106H174V79Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.996 85.7233C148.483 88.0688 147.798 90.8534 148.051 93.6332C148.305 96.4131 149.481 99.0283 151.393 101.062C153.305 103.096 155.842 104.431 158.601 104.855C161.36 105.279 164.182 104.767 166.616 103.401C169.051 102.036 170.958 99.8943 172.034 97.3187C173.11 94.7431 173.293 91.8815 172.554 89.1898C171.815 86.4981 170.196 84.1312 167.955 82.4665C165.714 80.8017 162.981 79.9347 160.191 80.0038L160.5 92.5L149.996 85.7233Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11947_87552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.996 85.7233C148.483 88.0688 147.798 90.8534 148.051 93.6332C148.305 96.4131 149.481 99.0283 151.393 101.062C153.305 103.096 155.842 104.431 158.601 104.855C161.36 105.279 164.182 104.767 166.616 103.401C169.051 102.036 170.958 99.8943 172.034 97.3187C173.11 94.7431 173.293 91.8815 172.554 89.1898C171.815 86.4981 170.196 84.1312 167.955 82.4665C165.714 80.8017 162.981 79.9347 160.191 80.0038L160.5 92.5L149.996 85.7233Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.996 85.7233C148.483 88.0688 147.798 90.8534 148.051 93.6332C148.305 96.4131 149.481 99.0283 151.393 101.062C153.305 103.096 155.842 104.431 158.601 104.855C161.36 105.279 164.182 104.767 166.616 103.401C169.051 102.036 170.958 99.8943 172.034 97.3187C173.11 94.7431 173.293 91.8815 172.554 89.1898C171.815 86.4981 170.196 84.1312 167.955 82.4665C165.714 80.8017 162.981 79.9347 160.191 80.0038L160.5 92.5L149.996 85.7233Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.661 101.339C153.124 102.801 154.927 103.878 156.908 104.473C158.889 105.067 160.987 105.161 163.013 104.745C165.039 104.329 166.931 103.417 168.518 102.09C170.105 100.763 171.338 99.0632 172.106 97.1427C172.874 95.2222 173.154 93.141 172.92 91.0858C172.686 89.0305 171.945 87.0655 170.765 85.3669C169.585 83.6682 168.001 82.2891 166.156 81.353C164.312 80.417 162.264 79.9534 160.196 80.0037L160.5 92.5L151.661 101.339Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 102.873C166.23 102.873 170.875 98.228 170.875 92.498C170.875 86.7681 166.23 82.123 160.5 82.123C154.77 82.123 150.125 86.7681 150.125 92.498C150.125 98.228 154.77 102.873 160.5 102.873Z",
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 105.125C167.473 105.125 173.125 99.4726 173.125 92.5C173.125 85.5274 167.473 79.875 160.5 79.875C153.527 79.875 147.875 85.5274 147.875 92.5C147.875 99.4726 153.527 105.125 160.5 105.125Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 102.877C166.23 102.877 170.875 98.2319 170.875 92.502C170.875 86.772 166.23 82.127 160.5 82.127C154.77 82.127 150.125 86.772 150.125 92.502C150.125 98.2319 154.77 102.877 160.5 102.877Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11947_87552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 110,
    width: 27,
    height: 27
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M174 110H147V137H174V110Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.996 116.723C148.483 119.069 147.798 121.853 148.051 124.633C148.305 127.413 149.481 130.028 151.393 132.062C153.305 134.096 155.842 135.431 158.601 135.855C161.36 136.279 164.182 135.767 166.616 134.401C169.051 133.036 170.958 130.894 172.034 128.319C173.11 125.743 173.293 122.881 172.554 120.19C171.815 117.498 170.196 115.131 167.955 113.466C165.714 111.802 162.981 110.935 160.191 111.004L160.5 123.5L149.996 116.723Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11947_87552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.996 116.723C148.483 119.069 147.798 121.853 148.051 124.633C148.305 127.413 149.481 130.028 151.393 132.062C153.305 134.096 155.842 135.431 158.601 135.855C161.36 136.279 164.182 135.767 166.616 134.401C169.051 133.036 170.958 130.894 172.034 128.319C173.11 125.743 173.293 122.881 172.554 120.19C171.815 117.498 170.196 115.131 167.955 113.466C165.714 111.802 162.981 110.935 160.191 111.004L160.5 123.5L149.996 116.723Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.996 116.723C148.483 119.069 147.798 121.853 148.051 124.633C148.305 127.413 149.481 130.028 151.393 132.062C153.305 134.096 155.842 135.431 158.601 135.855C161.36 136.279 164.182 135.767 166.616 134.401C169.051 133.036 170.958 130.894 172.034 128.319C173.11 125.743 173.293 122.881 172.554 120.19C171.815 117.498 170.196 115.131 167.955 113.466C165.714 111.802 162.981 110.935 160.191 111.004L160.5 123.5L149.996 116.723Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.661 132.339C153.124 133.801 154.927 134.878 156.908 135.473C158.889 136.067 160.987 136.161 163.013 135.745C165.039 135.329 166.931 134.417 168.518 133.09C170.105 131.763 171.338 130.063 172.106 128.143C172.874 126.222 173.154 124.141 172.92 122.086C172.686 120.031 171.945 118.066 170.765 116.367C169.585 114.668 168.001 113.289 166.156 112.353C164.312 111.417 162.264 110.953 160.196 111.004L160.5 123.5L151.661 132.339Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 133.873C166.23 133.873 170.875 129.228 170.875 123.498C170.875 117.768 166.23 113.123 160.5 113.123C154.77 113.123 150.125 117.768 150.125 123.498C150.125 129.228 154.77 133.873 160.5 133.873Z",
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 136.125C167.473 136.125 173.125 130.473 173.125 123.5C173.125 116.527 167.473 110.875 160.5 110.875C153.527 110.875 147.875 116.527 147.875 123.5C147.875 130.473 153.527 136.125 160.5 136.125Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 133.877C166.23 133.877 170.875 129.232 170.875 123.502C170.875 117.772 166.23 113.127 160.5 113.127C154.77 113.127 150.125 117.772 150.125 123.502C150.125 129.232 154.77 133.877 160.5 133.877Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInsThumbnail);
export default __webpack_public_path__ + "static/media/check-ins-thumbnail.e6bc405d1566e2396c230d02f7e42f49.svg";
export { ForwardRef as ReactComponent };